import { useContext, useMemo } from "react";
import { Divider, Icon, Typography } from "@mui/material";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { getFormatDate } from "@/helpers/utils";
import { BRAND_CONST } from "@/config/constants";

type PageHeaderProps = {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  iconImage?: string;
  gritting?: React.ReactNode;
  message?: React.ReactNode;
  hideBelowSection?: boolean;
  showName?: boolean;
  showLastUpdate?: boolean;
  showHr?: boolean;
};

type PageHeaderContext = {
  loggedInUser?: {
    first_name?: string;
    last_name?: string;
  };
  selectedBrand?: {
    id?: number;
    dashboard_last_updated?: string;
  };
};

// Brands for which data as of is hidden.
const BRANDS_TO_HIDE_DATA_AS_OF = [
  BRAND_CONST.POPEYES_BRAND_ID,
  BRAND_CONST.PEETS_COFFEE_BRAND_ID,
  BRAND_CONST.JACK_IN_THE_BOX_BRAND_ID,
  BRAND_CONST.BURGER_KING_BRAND_ID,
  BRAND_CONST.JASON_DELI_BRAND_ID,
  BRAND_CONST.PAPA_MURPHY_BRAND_ID,
  BRAND_CONST.POPEYES_LOUISIANA_KITCHEN_CANADA_BRAND_ID,
  BRAND_CONST.CORNER_BAKERY_BRAND_ID,
  BRAND_CONST.CICIS_PIZZA_BRAND_ID,
  BRAND_CONST.BUCA_DI_BEPPO,
  BRAND_CONST.PAPA_JOHNS,
  BRAND_CONST.DOMINOS_BRAND_ID,
  BRAND_CONST.PIZZA_BRAND_ID,
  BRAND_CONST.TIJUANA_FLATS_BRAND_ID,
  BRAND_CONST.DISCOVER_STRENGTH_BRAND_ID,
  BRAND_CONST.BOARD_AND_BRUSH_BRAND_ID,
];

export default function PageHeader({
  title = "",
  icon = "",
  iconImage = "",
  gritting = "Welcome back",
  message = "",
  hideBelowSection = false,
  showName = false,
  showLastUpdate = false,
  showHr = true,
}: PageHeaderProps) {
  const { loggedInUser, selectedBrand } = useContext(
    GlobalContext
  ) as PageHeaderContext;

  const lastUpdatedDate = useMemo(() => {
    return selectedBrand?.dashboard_last_updated
      ? getFormatDate(selectedBrand?.dashboard_last_updated)
      : "";
  }, [selectedBrand]);

  return (
    <div className="page-header">
      {hideBelowSection === false && (
        <div className="row mb-3 align-items-center d-flex justify-content-between">
          <div className="col">
            {title ? (
              <div className="page-title">
                {iconImage ? (
                  <Icon
                    className="img-fluid page-title-icon page-title-icon-image"
                    component="img"
                    src={iconImage}
                  />
                ) : null}
                {icon ? (
                  <Icon className="page-title-icon" color="primary">
                    {icon}
                  </Icon>
                ) : null}

                <Typography component="h1" variant="h5">
                  {title}
                </Typography>
              </div>
            ) : null}
            {showName && (
              <Typography component="h1" variant="h5">
                Hi! {gritting}{" "}
                <Typography
                  component="span"
                  variant="h5"
                  className="text-capitalize"
                  color="text.primary"
                >
                  {loggedInUser?.first_name?.concat(
                    ` ${loggedInUser?.last_name}`
                  )}
                  !
                </Typography>
              </Typography>
            )}
            {message && (
              <div className="w-100">
                <Typography variant="caption">{message}</Typography>
              </div>
            )}
          </div>
          {showLastUpdate &&
          (BRANDS_TO_HIDE_DATA_AS_OF.includes(selectedBrand?.id as number)
            ? false
            : true) ? (
            <div className="col-sm-4">
              {lastUpdatedDate && (
                <div className="last-updated">
                  <Typography variant="body2">Data as of</Typography>
                  <Typography
                    variant="body1"
                    color="text.primary"
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    {lastUpdatedDate}
                  </Typography>
                </div>
              )}
            </div>
          ) : null}

          {/* {settings?.brandSettings?.has_brand_resource ? (
            <div className="col-12 pt-1 d-flex justify-content-end">
              {showButton && (
                <MuiDarkButton
                  size="small"
                  component={Link}
                  to={{
                    pathname: `/resource-center/${selectedBrand?.id}`,
                    state: { from: "/dashboard" },
                  }}
                  variant="contained"
                  disableElevation
                  className="px-3 mt-2"
                >
                  Resource Center
                </MuiDarkButton>
              )}
            </div>
          ) : null} */}
        </div>
      )}
      {showHr && <Divider style={{ margin: "20px 0" }} />}
    </div>
  );
}
